import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3660c17f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "error-bottom"
}
const _hoisted_2 = {
  key: 1,
  class: "dv-input dv-input-read"
}
const _hoisted_3 = { key: 0 }

import {  IonLabel} from '@ionic/vue';
import { PropType } from 'vue'; 

export default /*#__PURE__*/_defineComponent({
  __name: 'ControlApp2',
  props: {
    tipo:
    {
      type: Number,
      default: 1
    },
    error: 
    {
      type: String,
      default: ''
    },
    edit:
    {
      type: Boolean,
      default: true
    },    
    text:
    {
      type: String,
      default: ''
    },    
    required:
    {
      type: Boolean,
      default: true
    },
    value:
    {
      type: Object as PropType<any>,
      default: null,
      required: false
    },
    border:Boolean,
    ellipsis:Boolean,
    islink:Boolean,
    display:String,
    type:String,
    smallFont:Boolean
  },
  emits: ['onLink'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const onLinked = (ev: any) => 
{
  emit('onLink',ev);  
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.edit)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["dv-input", {'lbl-required':__props.required}])
        }, [
          _createVNode(_unref(IonLabel), {
            class: _normalizeClass(["label-text", {'label-text-small':__props.value||__props.smallFont,'noBold':__props.smallFont}])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.text) + " ", 1),
              _renderSlot(_ctx.$slots, "default"),
              (__props.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.error), 1))
                : _createCommentVNode("", true)
            ]),
            _: 3
          }, 8, ["class"])
        ], 2))
      : _createCommentVNode("", true),
    (!__props.edit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(IonLabel), {
            class: _normalizeClass(["label-text", {'label-text-small':__props.value || __props.display,'text-short':__props.ellipsis}])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.text) + " ", 1),
              (__props.tipo === 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.value.value), 1))
                : _createCommentVNode("", true),
              (__props.tipo === 2)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: _normalizeClass({'eLinkCustom':__props.islink}),
                    onClick: onLinked
                  }, _toDisplayString(__props.display), 3))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})